import QueryBuilderEnvService from "../../../services/env-service";

/**
 * This interface houses all the available endpoints of this package.
 */
class ApiEndpoints {

    /**
     * The base url of the api endpoints of this package.
     * @private
     */
    private static baseUrl: string = QueryBuilderEnvService.ApiUrl.concat('/api');

    /**
     * The controllers of the api endpoints.
     * @private
     */
    private static controllers = {
        queryBuilder: this.baseUrl.concat("/UiComponent"),
    }

    /**
     * The endpoints specific for the data-grid controller of the server api.
     */
    static queryBuilder = {
        baseUrl: this.controllers.queryBuilder,
        getData: this.controllers.queryBuilder.concat('/GetApplicationComponents'),
        saveData: this.controllers.queryBuilder.concat('/Save'),
    }
}


export default ApiEndpoints;
